import React from 'react'
import { useTranslation } from 'react-i18next'
import Flex from 'typescript-styled-flex'
import {
  FiCopy,
  FiCornerUpRight,
  FiEdit2,
  FiImage,
  FiPlus,
} from 'react-icons/fi'
import { LimitGird, LimitItem } from '../../components/PremiumLimitModal'
import { is } from '../../components/MediaQuery'
import Button from '../../components/Template/Button'
import slide1 from '../../assets/premium_slider/slide1/img-modal-premium-1.png'
import slide2 from '../../assets/premium_slider/slide2/img-modal-premium-2.png'
import slide3 from '../../assets/premium_slider/slide3/img-1-modal-premium-3.png'
import slide4 from '../../assets/premium_slider/slide4/img-modal-premium-4.png'
import PremiumModal from '../../components/PremiumModal'
import { driver } from '../../database/localStorage'
import { CredentialsStorage } from '../../database/localStorage/names'
import Slider from './Components/Slider'
import SliderItem from './Components/SliderItem'
import { getPanelUrlForEnv } from '../../utils/ApiUrl'

function redirect() {
  const key = driver.getItem(CredentialsStorage.AccessToken, '')
  //var EnvUrl = getApiUrlForEnv()
  window.open(
    `${getPanelUrlForEnv()}/index/login?autologinkey=${key}&redirect=/payment`,
    '_blank',
  )
}

function PremiumInfoModal({
  open,
  close,
}: IPremiumInfoModalProps & IPremiumInfoModalDispatch) {
  const isDesktop = is.desktop()
  const { t } = useTranslation()

  return (
    <PremiumModal
      open={open}
      close={close}
      buttons={
        <Button style={{ width: '100%' }} primary={true} onClick={redirect}>
          {t('payment_activity')}
        </Button>
      }
    >
      <Flex
        full={true}
        row={isDesktop}
        column={!isDesktop}
        style={{ minHeight: isDesktop ? '420px' : 'unset' }}
      >
        <Flex column={true} style={{ width: isDesktop ? '50%' : '100%' }}>
          <LimitGird padding={'10px'}>
            <LimitItem
              label={t('z677_adding_reservations')}
              icon={<FiPlus size={20} />}
              state={6}
              limit={6}
              info={true}
            />
            <LimitItem
              label={t('info_premium_edit_reservations')}
              icon={<FiEdit2 size={20} />}
              state={6}
              limit={6}
              info={true}
            />
            <LimitItem
              label={t('z677_copying_reservations')}
              icon={<FiCopy size={20} />}
              state={3}
              limit={3}
              info={true}
            />
            <LimitItem
              label={t('z677_moving_reservations')}
              icon={<FiCornerUpRight size={20} />}
              state={3}
              limit={3}
              info={true}
            />
            <LimitItem
              label={t('info_detail_header13')}
              icon={<FiImage size={20} />}
              state={false}
              limit={true}
              info={true}
            />
          </LimitGird>
        </Flex>

        {isDesktop && (
          <div
            style={{
              borderLeft: '1px solid rgb(235, 237, 239)',
              margin: '0px 10px',
              minHeight: '100%',
              width: '1px',
            }}
          />
        )}

        <Flex
          alignCenter={true}
          justifyCenter={true}
          style={
            isDesktop
              ? { width: '50%' }
              : {
                  height: '100%',
                  maxHeight: '455px',
                  minHeight: '455px',
                  width: '100%',
                }
          }
        >
          <Slider>
            <SliderItem
              header={t('BBO_1002_slider_1_header')}
              label={t('BBO_1002_slider_1_info')}
              footer={t('BBO_1002_slider_footer')}
              image={slide1}
            />
            <SliderItem
              header={t('z677_no_adds')}
              label={t('BBO_1002_slider_2_info')}
              footer={t('BBO_1002_slider_footer')}
              image={slide2}
            />
            <SliderItem
              header={t('BBO_1002_slider_3_header')}
              label={t('BBO_1002_slider_3_info')}
              footer={t('BBO_1002_slider_footer')}
              image={slide3}
              downloadButtons={true}
            />
            <SliderItem
              header={t('BBO_1002_slider_4_header')}
              label={t('BBO_1002_slider_4_info')}
              footer={t('BBO_1002_slider_footer')}
              image={slide4}
              maxWidth={'80%'}
            />
          </Slider>
        </Flex>
      </Flex>
    </PremiumModal>
  )
}

export default PremiumInfoModal

export interface IPremiumInfoModalProps {
  open?: boolean
}

export interface IPremiumInfoModalDispatch {
  close?: () => void
}
